import { render, staticRenderFns } from "./SubFolderDocumentGeneric.vue?vue&type=template&id=5927a40d&scoped=true&"
import script from "./SubFolderDocumentGeneric.vue?vue&type=script&lang=js&"
export * from "./SubFolderDocumentGeneric.vue?vue&type=script&lang=js&"
import style0 from "./SubFolderDocumentGeneric.vue?vue&type=style&index=0&id=5927a40d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5927a40d",
  null
  
)

export default component.exports